import React from 'react';
import isFunction from 'lodash/isFunction';
import CustomerPhoneNumberModal from './CustomerPhoneNumberModal';

const { UI, Customer } = Mobi2Go;

let modal;
let component;
let global_on_complete_callback;
let global_on_cancel_callback;

const onComplete = () => {
    if (modal) {
        modal.setIsClosable(true);
        modal.close();
    }
    if (isFunction(global_on_complete_callback)) {
        global_on_complete_callback();
        global_on_complete_callback = null;
        global_on_cancel_callback = null;
    }
};

const onCancel = () => {
    if (modal) {
        modal.close();
    }
    if (isFunction(global_on_cancel_callback)) {
        global_on_cancel_callback();
        global_on_complete_callback = null;
        global_on_cancel_callback = null;
    }
};

Mobi2Go.onReady(() => {
    modal = UI.ExternalModal.create(
        'customer-phone-number',
        <CustomerPhoneNumberModal
            onComplete={onComplete}
            onCancel={onCancel}
            ref={ref => {
                component = ref;
            }}
        />,
        {
            'data-view': 'customer-verification',
            className: 'm2g-customer-verification',
        }
    );

    modal.mount();
});

Customer.bind(
    'requestPhoneNumber',
    (on_complete_callback, on_cancel_callback) => {
        if (!Customer.isLoggedIn()) {
            return;
        }

        if (!!Customer.getPhoneNumber()) {
            return;
        }

        if (!component) {
            return;
        }

        global_on_complete_callback = on_complete_callback;
        global_on_cancel_callback = on_cancel_callback;

        modal.setIsClosable(false);
        modal.open();
    }
);
